<app-header></app-header>
<div class="body-container clearfix">
	<div class="row">
		<div class="col-12">
			<app-app-header [step]="step"></app-app-header>
		</div>
	</div>
	<div class="row">
		<div class="col-12">
			<app-business-information [hidden]="step != 1" (continueClicked)="showOwnerClicked($event);"
				[industries]="industries" [businessTypes]="businessTypes" [businessInfo]="appInfo"
				[statesOfIncorporation]="statesOfIncorporation" [maxRequestedAmount]="maxRequestedAmount"
				(soleContinueClicked)="soleContinueClicked();" [token]="token" [referralPage]="referralPage"
				[submitted]="businessSubmitted">
			</app-business-information>
			<app-owners-information *ngIf="step == 2" [hidden]="step != 2"
				(continueClicked)="showCompleteApplicationClicked($event);" [owners]="owners"
				[statesIssued]="statesOfIncorporation" (backClicked)="showBusinessClicked();" [appInfo]="appInfo"
				[token]="token" [referralPage]="referralPage"
				[businessEmail]="appInfo.form.controls.primaryContactEmail">
			</app-owners-information>
			<app-sole-owner-information *ngIf="step == 5" [hidden]="step != 5"
				(continueClicked)="soleCompleteApplicationClicked($event);" [owner]="sOwner"
				[statesIssued]="statesOfIncorporation" (backClicked)="showBusinessClickedFS();" [appInfo]="appInfo"
				[token]="token" [referralPage]="referralPage">
			</app-sole-owner-information>
			<app-finicity *ngIf="step == 3" [applicationId]="applicationId"
				(onFinicityCompleted)="onFinicityCompleted($event)" [referralPage]="referralPage"
				(onFinicityErrorCompleted)="onFinicityErrorCompleted($event)" [token]="token"
				(onFinicityLinkSentSuccess)="showFinicityLinkSent($event)"
				(onFinicityLinkSentError)="showErrorDialog($event)" [primaryOwner]="primaryOwner"></app-finicity>
			<app-instant-results [hidden]="step != 4" [offers]="offers" [dbaName]="dbaName"></app-instant-results>
			<!--<app-ach-information [hidden]="step != 3" (continueClicked)="showEquipmentClicked($event);"
				[states]="statesOfIncorporation" [achInfo]="achInfo" (backClicked)="backToOwnersClicked();">
			</app-ach-information>
			<app-equipment-information [hidden]="step != 4" (continueClicked)="showCompleteApplicationClicked($event);"
				[equipmentItems]="equipmentItems" [equipmentDescription]="equipmentDescription"
				[equipmentSetup]="equipmentSetup" (backClicked)="backToACHClicked();">
			</app-equipment-information>-->
		</div>
	</div>
	<app-error-dialog [modalId]="errorId" [title]="errorTitle" [messageA]="errorMessageA" [messageB]="errorMessageB"
		[messageC]="errorMessageC" [messageBClass]="errorMessageBClass" [dialogClass]="'w600'">
	</app-error-dialog>
	<app-agreement></app-agreement>
</div>